/* * 本页面为通行证新增和通行证修改界面 * 通过pageType字段来区分：1新增，2修改 *
*/
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="通行证"
              prop="forms.passcheckNo"
              :rules="[
                {
                  required: true,
                  message: '请输入通行证',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.passcheckNo"
                placeholder="通行证"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="车辆"
              prop="forms.vehicleId"
              ref="vehicleIdElement"
              :rules="[
                {
                  required: true,
                  message: '请选择车辆',
                  trigger: 'change'
                }
              ]"
            >
              <e6Select
                :dataList="vehicleTreeList"
                :filterable="true"
                slotTemplate="tree"
                :issingleleaf="true"
                ref="vehicleTreeSelect"
                :placeholder="'车辆'"
                widthData="300px"
                @multipleSelect="handleSelectOrganization"
              ></e6Select>
            </el-form-item>
            <br />
            <el-form-item
              class="remarkWidth"
              prop="forms.remark"
              label="备注"
              :rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model.number="slotForms.forms.remark"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
<script>
import { FetchFindById, SavePassCheck } from "@/api/base/passCheck";
import { FetchVehicleTree } from "@/api/base/vehicle";
import resizeListener from "_private/mixins/resizeListener";
import { CheckRemarkLength, CheckComparyNameLength } from "@/utils/validation";
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/basePassCheckList",
          isRedirect: true,
          meta: {
            title: "通行证管理"
          }
        }
      ],
      formExtend: {
        forms: {
          vehicleId: "",
          passcheckNo: "",
          remark: ""
        },
        extends: []
      },
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      CheckComparyNameLength: CheckComparyNameLength,
      loadingState: false,
      vehicleTreeList: [],
      idList: [],
      isFirstLoad: true
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle = this.pageType === "1" ? "通行证新增" : "通行证修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    //初始化区位树

      if (this.pageType !== "1") {
        this.FetchFindById({ id: this.id });
        this.editState = true;
      }else{
          this.initVehicleTree();
      }

    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
  },
  mounted() {
    let idStr = this.$route.query.vehicleIds;
    if (idStr) {
      this.idList = idStr.split(",");
    }
  },
  methods: {
    //初始化区位树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
            this.$nextTick(() => {
                this.setNodeCheck(this.idList);
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSelectOrganization(val) {
      const orgArr = val.map(v => v.id);
      this.formExtend.forms.vehicleId = orgArr.join(",");
      if(this.formExtend.forms.vehicleId){
          this.$refs['vehicleIdElement'].clearValidate();
      }


    },
    //设置勾选
    setNodeCheck(idArr) {
      console.log(this.vehicleTreeList)
      if (idArr.length > 0 ) {
          this.$refs.vehicleTreeSelect.setSelectList(idArr);
      } else {
        this.$nextTick(() => {
          this.$refs.vehicleTreeSelect.cleanSelectAll();
        });
      }
    },
    // 修改通行证数据时，先获取通行证数据信息
    FetchFindById(response) {
      FetchFindById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result);
          this.idList.push(response.result.vehicleId);
          this.initVehicleTree();
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 新增，修改通行证数据
    SavePassCheck(response) {
      SavePassCheck(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增通行证信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/basePassCheckList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        this.loadingState = true;
        this.SavePassCheck(Object.assign({}, this.formExtend.forms));
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/basePassCheckList");
    }
  }
};
</script>

<style lang="scss" scoped>
.remarkWidth {
  width: 70%;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 500px;
  }
}
</style>
